import TermsByCategory from "./terms-by-category";

export default TermsByCategory;